import { FC, useEffect } from 'react';
import Button from 'v3/common/components/Button';
import PortalToTarget from 'v3/common/components/PortalToTarget';
import UserInput from 'v3/common/components/UserInput';
import { BrokerSpecificComponentsProps } from 'v3/pages/LandingPage/Default/BannerSection/UserAuth/LoginModal/types.type';

const Profitmart: FC<BrokerSpecificComponentsProps> = ({
  userConfigs,
  brokerSpecificHandles,
  switchPage,
}) => {
  const { updatePartialConfigs, validateClientId, reDirectPage, isMobile } = brokerSpecificHandles;
  const {
    clientId,
    apiKey,
    ipAddress,
    selectedBrokerConfig,
    isLoading,
    isClientValidated,
    shouldShowApiKey,
  } = userConfigs;

  const broker = selectedBrokerConfig?.id;
  const isNewUser = isClientValidated && shouldShowApiKey;
  const isExistingUser = isClientValidated && !shouldShowApiKey;

  useEffect(() => {
    if (isExistingUser) reDirectPage({}, false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isExistingUser]);

  return (
    <form
      id={`${broker}-form`}
      onSubmit={(e) => {
        e.preventDefault();
        if (!isClientValidated) return validateClientId();
        return reDirectPage({}, false);
      }}
    >
      <UserInput
        autoFocus={!isMobile}
        labelValue="Client Id"
        type="text"
        id={`${broker}-id`}
        value={clientId}
        disabled={isClientValidated}
        onHandleChange={(value) => updatePartialConfigs({ clientId: value })}
      />

      {isNewUser && (
        <>
          <UserInput
            labelValue="Secret Code"
            id={`${broker}-secret-key`}
            value={apiKey}
            placeholder="Enter API Secret"
            onHandleChange={(value) => updatePartialConfigs({ apiKey: value })}
          />

          <UserInput
            labelValue="Static IP Address"
            id={`${broker}-ip-address`}
            value={ipAddress}
            onHandleChange={(value) => updatePartialConfigs({ ipAddress: value })}
          />
        </>
      )}

      <button type="button" onClick={() => switchPage()}>
        <i className="fa-regular fa-gear fa-spin" />
        How to generate API Secret ?
      </button>

      <PortalToTarget targetClassName="login-modal__footer" allowForWeb>
        {!isClientValidated && (
          <Button form={`${broker}-form`} type="submit" isLoading={isLoading}>
            Validate
          </Button>
        )}
        {isNewUser && (
          <Button form={`${broker}-form`} type="submit" isLoading={isLoading}>
            Login
          </Button>
        )}
      </PortalToTarget>
    </form>
  );
};

export default Profitmart;
